import { MARQUEE_ITEMS } from "@/lib/site";

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex w-max items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span
        key={item}
        className="flex items-center whitespace-nowrap font-mono text-sm tracking-[0.2em] text-white/70"
      >
        <span className="px-8">{item}</span>
        <span className="text-accent">//</span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="tech-marquee" className="marquee overflow-hidden border-y border-white/10 py-6">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
